import React from 'react';
import { FiDownload } from 'react-icons/fi';

const PartnerTableExportButton = ({ onClick, disabled = false, itemCount = 0 }) => (
  <button
    type="button"
    className="partner-table-export-btn"
    onClick={onClick}
    disabled={disabled || itemCount === 0}
    title={itemCount === 0 ? 'No projects to export' : `Export ${itemCount} project${itemCount === 1 ? '' : 's'}`}
  >
    <FiDownload aria-hidden="true" />
    <span>Export</span>
  </button>
);

export default PartnerTableExportButton;
